<template>
  <UApp :locale="localeMap[locale as TSupportedLocale]">
    <router-view />
    <Modals />
    <div
      v-if="!isProd"
      class="fixed top-1 right-1 z-9999 text-[10px] leading-none pointer-events-none select-none"
    >
      {{ commit }}
    </div>
  </UApp>
</template>

<script setup lang="ts">
import type { Locale, Messages } from '@nuxt/ui'
import { hideSplashScreen } from 'vite-plugin-splash-screen/runtime'
import { zh_cn, en } from '@nuxt/ui/locale'

const { locale } = useI18n({ useScope: 'global' })

const isProd = import.meta.env.VITE_ENV === 'prod'
const commit = import.meta.env.VITE_APP_VERSION

const localeMap: Record<TSupportedLocale, Locale<Messages>> = {
  'zh-CN': zh_cn,
  'en-US': en
}

useRequestChatGlobalSubscription()

onMounted(() => {
  hideSplashScreen()
})
</script>
